import { upsertOddsAdjustments } from "@/api/oddsAdjustments";
import { useMutation } from "@tanstack/react-query";

export const useUpsertOddsAdjustments = () => {
  return useMutation({
    mutationFn: upsertOddsAdjustments,
  });
};
